<template>
  <div>
    <div v-if="loading" class="">
      <div id="nprogress" style="">
        <div class="spinner" role="spinner">
          <div class="spinner-icon"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    loading() {
      return this.$store.state.isLoading;
    },
  },
};
</script>

<style>
#nprogress {
  pointer-events: none;
  position: fixed;
  z-index: 1031;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 100%;
  height: 2px;
}
#nprogress .spinner {
  position: fixed !important;
  z-index: 999 !important;
  height: 2em !important;
  width: 2em !important;
  overflow: visible !important;
  margin: auto !important;
  top: 0 !important;
  left: 0 !important;
  bottom: 0 !important;
  right: 0 !important;
  display: block;
}
#nprogress .spinner::after {
  content: "";
  height: 100vh;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5) !important;
  display: block;
  z-index: 1032222 !important;
  position: fixed;
  top: 0;
  left: 0;
}

#nprogress .spinner-icon {
  width: 50px !important;
  height: 50px !important;
  border: solid 5px transparent !important;
  border-top-color: #253d5d !important;
  border-bottom-color: #2595b8 !important;
  box-sizing: border-box;
  border-radius: 50%;
  -webkit-animation: nprogress-spinner 400ms linear infinite;
  animation: nprogress-spinner 400ms linear infinite;
}

.nprogress-custom-parent {
  overflow: hidden;
  position: relative;
}

.nprogress-custom-parent #nprogress .spinner{
  position: absolute;
}

@-webkit-keyframes nprogress-spinner {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes nprogress-spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
